import PropTypes from 'prop-types';
import { or } from 'airbnb-prop-types';
import { responsivePropTypes } from '../../themes/propTypes';
import { commonPropTypes, } from '../../interfaces/commonProps';
import { spacingPropTypes, } from '../../interfaces/layoutProps';
export var AlignMap;
(function (AlignMap) {
    AlignMap["auto"] = "auto";
    AlignMap["baseline"] = "baseline";
    AlignMap["center"] = "center";
    AlignMap["end"] = "flex-end";
    AlignMap["start"] = "flex-start";
    AlignMap["stretch"] = "stretch";
})(AlignMap || (AlignMap = {}));
export const align = [
    'auto',
    'baseline',
    'center',
    'end',
    'start',
    'stretch',
];
export const grow = ['inherit', 'unset', 'initial'];
export const shrink = ['inherit', 'unset', 'initial'];
export const layoutItemPropTypes = {
    align: or([
        PropTypes.oneOf(align),
        responsivePropTypes(PropTypes.oneOf(align)),
    ]),
    basis: or([
        PropTypes.string,
        responsivePropTypes(PropTypes.string),
    ]),
    grow: or([
        PropTypes.string,
        PropTypes.oneOf(grow),
        responsivePropTypes(or([PropTypes.string, PropTypes.oneOf(grow)])),
    ]),
    shrink: or([
        PropTypes.string,
        PropTypes.oneOf(shrink),
        responsivePropTypes(or([PropTypes.string, PropTypes.oneOf(shrink)])),
    ]),
    ...commonPropTypes,
    ...spacingPropTypes,
};
//# sourceMappingURL=LayoutItem.types.js.map